import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class QuestionsService {
  constructor(private http: HttpClientService) {}

  public update(questions): Observable<any> {
    let options = {
      questions,
    };
    return this.http
      .put("/api/questions/" + questions.id, options)
      .pipe(tap((_) => console.log("QuestionsService.update: Ok.")));
  }

  public create(body: any, questionable_type: string, questionable_id: string | number, category: string) {
    const options = {
      body: body,
      questionable_type: questionable_type,
      questionable_id: questionable_id,
      category: category,
    };
    return this.http.post("/api/questions", options).pipe(tap((_) => console.log("QuestionsService.create: Ok.")));
  }

  public getQuestionsByResource(questionable_type, questionable_id, category?) {
    const options = {
      params: {
        questionable_type: questionable_type,
        questionable_id: questionable_id,
        category: category,
      },
    };
    return this.http
      .get("/api/questions/questions_by_resource", options)
      .pipe(tap((_) => console.log("QuestionsService.getQuestionsByResource: Ok.")));
  }

  public updateQuestions(question_id, body) {
    return this.http
      .put(`/api/questions/${question_id}`, body)
      .pipe(tap((_) => console.log("QuestionsService.updateQuestions: Ok")));
  }

  public postQuestionForPhoneNumber(phone_number_id: number, body: any) {
    const options = {
      phone_number_id: phone_number_id,
      body: body,
    };

    return this.http
      .post("/api/questions/create_for_phone_number", options)
      .pipe(tap((_) => console.log("QuestionsService.postQuestionForPhoneNumber: Ok.")));
  }
}
